import z from "zod";
import { PropsInputSchema } from "@msys/backend-core-types";
export const ApplyItemActionContingentSchema = z.strictObject({
    type: z.literal("setDecisionContingencyPreselection"),
    decisionContingentItemPreselection: z.boolean().nullable(),
    itemId: z.string(),
    questionId: z.string(),
});
export const ApplyItemActionDecisionSchema = z.strictObject({
    type: z.literal("setDecisionSubitemsPreselection"),
    decisionSubitemsPreselection: z.string().array(),
    itemId: z.string(),
    questionId: z.string(),
});
export const ApplyitemActionPropsSchema = z.strictObject({
    type: z.literal("setEnterPropsValueEntries"),
    entries: PropsInputSchema.array(),
    itemId: z.string(),
    questionId: z.string(),
});
export const ApplyitemActionProductSchema = z.strictObject({
    type: z.literal("setSelectProduct"),
    itemId: z.string(),
    selection: z
        .strictObject({
        productArticleNumber: z.string(),
        productSupplierId: z.string(),
    })
        .nullable(),
    questionId: z.string(),
});
export const ApplyItemActionPlaceholderForTemplateSchema = z.strictObject({
    type: z.literal("setSelectPlaceholderForTemplateType"),
    itemId: z.string(),
    selectedTemplateId: z.string().nullable(),
    questionId: z.string(),
});
export const ApplyItemActionRecommendationsSchema = z.strictObject({
    type: z.literal("setRecommendations"),
    itemId: z.string(),
    recommendations: z
        .strictObject({
        recommendationId: z.string(),
        operation: z.enum(["include", "exclude"]),
    })
        .array(),
    questionId: z.string(),
});
export const ApplyItemActionSchema = z.discriminatedUnion("type", [
    ApplyItemActionContingentSchema,
    ApplyItemActionDecisionSchema,
    ApplyitemActionPropsSchema,
    ApplyitemActionProductSchema,
    ApplyItemActionPlaceholderForTemplateSchema,
    ApplyItemActionRecommendationsSchema,
]);
//# sourceMappingURL=schema.js.map